namespace $ {

	$mol_style_define( $shm_hitalama_project_codex, {
		height: '100%',
		minHeight: 0,
		Goal_settings: {
			display: 'none',
		},
	} )

}
